import { render, staticRenderFns } from "./ColumnBasic.vue?vue&type=template&id=4547d7cf&"
import script from "./ColumnBasic.vue?vue&type=script&lang=js&"
export * from "./ColumnBasic.vue?vue&type=script&lang=js&"
import style0 from "./ColumnBasic.vue?vue&type=style&index=0&id=4547d7cf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports